import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I am a software developer, not a 15 year old",
  "description": "",
  "published": "2012-03-22T00:00:00.000Z",
  "redirect_from": ["/blog/?p=4043"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`As a `}{`_`}{`computer guy `}{`_`}{`I often get asked to do various computer related things for people. Because obviously I work with computers all day and that means I can use every piece of software ever invented. Most of all it means I can fix any computer any time.`}</p>
    <p>{`But I'm not 15 anymore. It's been a while since I've been able to use any piece of software I don't use frequently - sometimes I barely use 5% of what a piece of software can do (I'm looking at you Emacs) and am completely oblivious to everything else.`}</p>
    <p>{`And yet, the requests come.`}</p>
    <p>{`So for future reference, here is a list of things I don't know anymore:`}</p>
    <p>{`<`}{`list off a bunch of random requests peopel keep making and wear your ignorance proud>`}</p>
    <p>{`<`}{`explain that this isn't so much ignorance as it is specialisation>`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      